import { convertToCNSPolyMesh } from '../translators/bingeom';
import { getOrFetchBinary, getHash } from '../modules/assets';

import MeshSmooth from './PolyMesh/MeshSmooth';

const ProxyMesh = {
  schema: {
    binary: { type: 'Binary', label: 'Binary Geometry File' },
    reducedBinary: { type: 'Binary', label: 'Reduced Binary Geometry File' },
    operatorDisplay: { type: 'Number', defaultValue: 1, label: 'Operator Display Type' },
    nbLevel: { type: 'Number', defaultValue: 1 }, // 1 -> only binary, 2 -> level0 and binary, 3 -> level0, level1, binary, ....
    level0: { type: 'Binary', label: 'Binary Geometry File' },
    level1: { type: 'Binary', label: 'Binary Geometry File' },
    level2: { type: 'Binary', label: 'Binary Geometry File' },
    level3: { type: 'Binary', label: 'Binary Geometry File' },
    level4: { type: 'Binary', label: 'Binary Geometry File' },
  },

  update: function (operator, primitive, { node, store, properties, previousResult, loaded }) {
    const visible = properties.visible;
    const binary = operator.binary;
    const fetch = visible || (properties.prefetch && loaded);
    const bingeom = fetch && binary && store.hasApi() && getOrFetchBinary(binary)(store);
    const mesh = bingeom && convertToCNSPolyMesh(bingeom, binary);
    //console.log('Mesh update', 'visible:', visible, 'prefetch:', properties.prefetch, 'fetch:', fetch, 'bingeom:', !!bingeom, node.name, mesh);
    primitive.mesh = mesh;
    primitive.previousMesh = previousResult && previousResult.mesh;
  },
};

const Instance = {
  schema: {
    geometry: { label: 'Mesh', plug: 'BinMesh', type: 'Plug' },
  },

  update: function (operator, primitive) {
    primitive.mesh = operator.geometry && operator.geometry.mesh;
  },
};

export default { ProxyMesh, MeshSmooth, Instance };



// WEBPACK FOOTER //
// ./src/operators/BinMesh.js